import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { EnvService } from '@app-services/env.service';
import '@capacitor-community/http';

import * as utf8 from 'crypto-js/enc-utf8';
import * as AES from 'crypto-js/aes';

import { Http } from '@capacitor-community/http';
import { Preferences } from '@capacitor/preferences';

import { jwtDecode } from "jwt-decode";
import { startRegistration, startAuthentication, browserSupportsWebAuthn } from '@simplewebauthn/browser';
import { environment } from '@app-environments/environment';
 

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  // Store the user data encrypted in the browser storage..
  cryptKey='NotAnotherL0velyK3yF0rT1m';

  // Flag used by other modules to see whether logged in or not...note that this can include
  // the case where the user details are retrieved from the browser storage.
  public isLoggedIn: boolean = false;

  constructor(private env: EnvService, public platform: Platform) { }

  // login - return the accessToken, but mainly get the user info and put it into this.env.global.user
  login(email: String, password: String, pin: String) 
  {
	  //console.log('Environment', this.env.API_URL + '/authentication');
    console.log('Environment', this.env.API_URL + '/authorization');
	
    const httpOptions = {
      method: 'POST',
      //url: this.env.API_URL + '/authentication',
      url: this.env.API_URL + '/authorization',
      headers: { 'Content-Type':  'application/json', },
      data: {strategy: this.env.STRATEGY, email: email, password: password, pin: pin}
    }

    return new Promise(async (resolve:any, reject:any) => 
    {
	    console.log('connecting to @', this.env.STRATEGY, this.env.API_URL);

      this.isLoggedIn = false;
      await Http.request(httpOptions).then(async (res:any) => 
      {
        
	      ///////////////////////////////////////////////////////////////////////////////////////////////////
        console.log('x-authentication-response',res);
        // Response status needs checking. 
				// If the call worked, we will see a 200 status
				// If it 'failed' we will see 400 or summin
				// If it really fails, the (err) section will collect that 
	  		console.log('x-server-response', res);

				if ((res.status == 200  || res.status == 201) && res.data && res.data.accessToken)
				{

					// Return successful body
  			  console.log('x-server-resolve-message-response', res.data);
  				// Userdata and token have been found let's keep them safe
			
			    // store token in local storage 
          var enc = AES.encrypt(JSON.stringify(res.data),this.cryptKey).toString();
          await Preferences.set( { key: 'vetpay-customer-user', value: enc }).catch((error) => 
          {
					  console.error('x-client-error-storing-item', error)
					  this.isLoggedIn = false;
					  delete this.env.global.user;
					  reject({ status: false, message: "Error storing encrypted user data"});
          });
          this.env.global.user = res.data;
          this.env['PAYWAY_KEY'] = res.data.paywayPublicKey;
          this.env['APPLICATION_MAX_AGE'] = res.data.applicationMaxAge;
  	      console.log('x-dataset-local-storage', this.env.global.user );
          this.isLoggedIn = true;
	  		  resolve(res.data.accessToken);

        } 
        else
        {
					// Return failure - fish out a message...
					console.log('x-server-reject-data-message-response', res);
					if (res.data && res.status && res.data.name && res.data.message)
					{
						reject ({ status:res.status, message:res.data.message, name: res.data.name });
					}
					else
					{
				    reject(res);
					}
			  }
      },(err) => {
	 		    console.log('x-login-error-reject',err);
			    reject(err); 
		  });
      /////////////////////////////////////////////////////////////////////////////////////////////////// 
    });

  }

  // authenticate - this uses strategy, email, password, pin
  authenticate(email: string, password: string, pin: string): Promise<{ success: boolean }> {
    return new Promise(async (resolve, reject) => {
      console.log('x-client-initiated-authorization', true);
      await Http.request({
        method: 'POST',
        url: this.env.API_URL + '/authorization',
        headers: { 'Content-Type': 'application/json' },
        data: { strategy: this.env.STRATEGY, email: email, password: password, pin: pin }
      }).then(
        (res: any) => {
          if (res && (res.statud == 200 || res.status == 201)) {
            resolve(res.data);
          } else {
            reject(res);
          }
        },
        (err: any) => {
          reject(err);
        }
      );
    });
  }
  

  register(fName: String, lName: String, email: String, password: String) 
  {
    const httpOptions = {
      method: 'POST',
      url: this.env.API_URL + '/users',
      headers: { 'Content-Type':  'application/json', },
      data: {email: email, password: password}
    }

    // TBC - this looks a little lightweight!!
    return new Promise(async (resolve:any, reject:any) =>
    {
	    console.log('x-client-initiated-registration',true);
      await Http.request(httpOptions).then((res:any) => 
      {
        console.log(res);
        if (res && res.data)
        {
          resolve();
        }
        else
        {
          reject();
        }
      },(err:any) => { reject(err); });
    });
    
      
  }

  isTrustedSessionValid(): boolean {
    
    let storedData = localStorage.getItem('loginData');
  
    if (!storedData) {
      console.log("No trusted session found in localStorage. Checking sessionStorage...");
      storedData = sessionStorage.getItem('loginData');
    }
    
    if (!storedData) {
      console.log("No trusted session found.");
      return false;
    }
  
    const parsedData = JSON.parse(storedData);
    const now = Date.now();
    const lastLogin = parsedData.timestamp;

    if (now - lastLogin > this.env.trustExpiry) {
      console.log("Trusted session expired. Logging out...");
      this.logout();
      return false;
    }
  
    console.log("Trusted session is still valid.");
    return true;
  }

  logout() 
  {
    return new Promise(async (resolve:any, _:any) =>
    {
	    this.isLoggedIn = false; 
	    console.log('x-client-initiated-logout',true);
      await Preferences.remove({key: 'vetpay-customer-user'});
	    delete this.env.global.user;
      localStorage.removeItem('loginData');
      sessionStorage.removeItem('loginData');
      resolve(true);
    });

  }

  // Logout if token has expired
  checkToken(token)
  {
    if (!token) { return false; }
    try {
      var decoded:any = jwtDecode(token);
      var dt = new Date().getTime();
      var exp = (decoded.exp * 1000) - dt;
      console.log(dt,decoded,exp);
      if (exp > 0)  { return true; }
    }
    catch (e)
    {
      console.log(e);
      return false;
    }
    return false;
  }

  async loadUser() 
  {
  
    return await Preferences.get({ key: 'vetpay-customer-user'}).then((enc:any) => 
    {
		  // get data from storage...
      if (!enc || !enc.value) 
      {
        this.env.global.user = null;
        this.isLoggedIn=false;
        return;
      }

      var data = AES.decrypt(enc.value, this.cryptKey).toString(utf8);
      if (data) { data = JSON.parse(data); }
      this.env.global.user=data;
      this.isLoggedIn=true;
	    return;

    }, (error:any) => {
		  this.env.global.user = null;
      this.isLoggedIn=false;
      return;
    });
  }

  async saveUserData(data: any): Promise<void> {
    var enc = AES.encrypt(JSON.stringify(data), this.cryptKey).toString();
    await Preferences.set({ key: 'vetpay-customer-user', value: enc }).catch((error) => {
      console.error('x-client-error-storing-item', error);
      this.isLoggedIn = false;
      delete this.env.global.user;
      throw new Error('Error storing encrypted user data');
    });
    this.env.global.user = data;
    this.env['PAYWAY_KEY'] = data.paywayPublicKey;
    this.env['APPLICATION_MAX_AGE'] = data.applicationMaxAge;
    console.log('x-dataset-local-storage', this.env.global.user);
    this.isLoggedIn = true;
  }

  isWebAuthnSupported(): boolean {
    return browserSupportsWebAuthn();
  }

  async usernameValidation(email: string): Promise<any> {
    const apiBase = environment.apiURL || this.env.API_URL;
    const url = `${apiBase}/authorizationcontrol?authentication=local&action=usernameValidation&username=${encodeURIComponent(email)}`;

    const res: any = await Http.request({
      method: 'GET',
      url: url,
      headers: { 'Content-Type': 'application/json' }
    });

    if ((res.status === 200 || res.status === 201) && res.data) {
      return res.data;
    }
    return { status: false, authenticationMethods: [] };
  }

  async passkeyStartAuthentication(email: string): Promise<any> {
    const apiBase = environment.apiURL || this.env.API_URL;
    const url = `${apiBase}/authorizationcontrol?authentication=passkey&action=generateAuthenticationOptions&username=${encodeURIComponent(email)}`;

    const optionsRes: any = await Http.request({
      method: 'GET',
      url: url,
      headers: { 'Content-Type': 'application/json' }
    });

    if (!optionsRes || (optionsRes.status !== 200 && optionsRes.status !== 201) || !optionsRes.data) {
      return false;
    }

    const optionsJSON = optionsRes.data;
    if (!optionsJSON || optionsJSON === false) {
      return false;
    }

    const asseResp = await startAuthentication({ optionsJSON });

    const authPayload = {
      strategy: 'passkey',
      username: email,
      authenticationResponse: JSON.stringify(asseResp)
    };

    const authRes: any = await Http.request({
      method: 'POST',
      url: `${apiBase}/authentication`,
      headers: { 'Content-Type': 'application/json' },
      data: authPayload
    });

    if ((authRes.status === 200 || authRes.status === 201) && authRes.data && authRes.data.accessToken) {
      await this.saveUserData(authRes.data);
      return authRes.data;
    } else {
      const msg = (authRes.data && authRes.data.message) ? authRes.data.message : 'Passkey authentication failed';
      throw new Error(msg);
    }
  }

  async passkeyGenerateRegistrationOptions(): Promise<any> {
    const apiBase = environment.apiURL || this.env.API_URL;
    const token = this.env.global.user && this.env.global.user.accessToken;

    const res: any = await Http.request({
      method: 'POST',
      url: `${apiBase}/authorizationcontrol`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      data: {
        authentication: 'passkey',
        action: 'generateRegistrationOptions'
      }
    });

    if ((res.status === 200 || res.status === 201) && res.data) {
      return res.data;
    }
    throw new Error((res.data && res.data.message) || 'Error generating registration options');
  }

  async passkeyVerifyRegistration(authenticationResponse: any): Promise<any> {
    const apiBase = environment.apiURL || this.env.API_URL;
    const token = this.env.global.user && this.env.global.user.accessToken;

    const res: any = await Http.request({
      method: 'POST',
      url: `${apiBase}/authorizationcontrol`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      data: {
        authentication: 'passkey',
        action: 'verifyRegistration',
        authenticationResponse
      }
    });

    if ((res.status === 200 || res.status === 201) && res.data) {
      return res.data;
    }
    throw new Error((res.data && res.data.message) || 'Error verifying registration response');
  }

  async getPasskeys(): Promise<any> {
    const apiBase = environment.apiURL || this.env.API_URL;
    const token = this.env.global.user && this.env.global.user.accessToken;

    const res: any = await Http.request({
      method: 'GET',
      url: `${apiBase}/authorizationcontrol/authenticationMethods`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    });

    if ((res.status === 200 || res.status === 201) && res.data) {
      return res.data.authenticationMethods || res.data;
    }
    return { passkeys: { status: false, publicKeys: [] } };
  }

  async removePasskey(publicKeyId: string): Promise<any> {
    const apiBase = environment.apiURL || this.env.API_URL;
    const token = this.env.global.user && this.env.global.user.accessToken;

    const res: any = await Http.request({
      method: 'POST',
      url: `${apiBase}/authorizationcontrol`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      data: {
        authentication: 'passkey',
        action: 'removePublicKey',
        publicKeyId
      }
    });

    if ((res.status === 200 || res.status === 201) && res.data) {
      return res.data;
    }
    throw new Error((res.data && res.data.message) || 'Error removing passkey');
  }

  async editPasskeyDeviceName(publicKey: { id: string, deviceName: string }): Promise<any> {
    const apiBase = environment.apiURL || this.env.API_URL;
    const token = this.env.global.user && this.env.global.user.accessToken;

    const res: any = await Http.request({
      method: 'POST',
      url: `${apiBase}/authorizationcontrol`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      data: {
        authentication: 'passkey',
        action: 'editPublicKeyDeviceName',
        publicKey
      }
    });

    if ((res.status === 200 || res.status === 201) && res.data) {
      return res.data;
    }
    throw new Error((res.data && res.data.message) || 'Error updating passkey name');
  }

}

